import { render, staticRenderFns } from "./ProductElements.vue?vue&type=template&id=6d5b3bc4&scoped=true&"
import script from "./ProductElements.vue?vue&type=script&lang=js&"
export * from "./ProductElements.vue?vue&type=script&lang=js&"
import style0 from "./ProductElements.vue?vue&type=style&index=0&id=6d5b3bc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5b3bc4",
  null
  
)

export default component.exports